import { render, staticRenderFns } from "./LogosContainer.vue?vue&type=template&id=0ee6784c"
import script from "./LogosContainer.vue?vue&type=script&lang=js"
export * from "./LogosContainer.vue?vue&type=script&lang=js"
import style0 from "./LogosContainer.vue?vue&type=style&index=0&id=0ee6784c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports